import Articles from 'articles';

export const handleArticles = (text: string) => {
  const words = text.split(' ');
  let output = '';
  for (let i = 0; i < words.length - 1; i += 1) {
    const word = words[i];
    if (word === 'a' || word === 'an') {
      const nextWord = words[i + 1];
      const correctArticle = Articles.articlize(nextWord).split(' ')[0];
      output += `${correctArticle} `;
    } else {
      output += `${word} `;
    }
  }
  output += words[words.length - 1];
  return output;
};
